import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import { useModal } from "../../../utils/hooks/useModal";
import { noop } from "lodash";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {useActionWithAccess} from "../../../utils/hooks/access";

const icon = (
    <FontAwesomeIcon
        icon={faCircleXmark}
        className="text-danger w-100 mb-5"
        fontSize={70}
    />
);

export const useDeleteModal = ({
    message,
    permission,
    onConfirm = noop,
    onCancel = noop,
}) => {
    const { t } = useTranslation();

    const head = useMemo(() => (
        <h2 className="mb-0 text-center font-weight-bolder">
            {t("are-you-sure")}
        </h2>
    ), [t])

    const { open, ...rest } = useModal({
        head,
        icon,
        message,
        color: "danger",
        onConfirm,
        onCancel,
    });

	const openWithAccess = useActionWithAccess(open, permission);

    return {
        open: permission ? openWithAccess : open,
        ...rest
    };
}
